module.exports = __webpack_public_path__ + "img/3-4.851cebe1.svg";